import GlobalStore from "../store/globalStore";

declare var mixpanel: any;

export interface IMixpanelObjInterface {
	event: string;
	[key: string]: any;
}

let isInitialized = false;
let lastIdentifiedLeadId = "";

export function initMixpanelService(token: string) {
	if (isInitialized || typeof mixpanel === "undefined" || !token) return;
	try {
		mixpanel.init(token, {
			persistence: "localStorage",
			debug: false,
			track_pageview: false,
			autocapture: {
				click: true,
				pageview: false,
				capture_text_content: false,
				input: false,
				scroll: false,
				submit: false,
			},
			record_sessions_percent: 10,
			record_mask_text_selector: "",
			record_block_selector: "",
		});
		isInitialized = true;
	} catch (e) {
		console.error("mixpanel init failed", e);
	}
}


export default function mixpanelService(mixpanelObj: IMixpanelObjInterface) {
	try {
		if (typeof mixpanel === "undefined") return;
		const { event, ...properties } = mixpanelObj;


		if (GlobalStore.leadId && GlobalStore.leadId !== lastIdentifiedLeadId) {
			mixpanel.identify(GlobalStore.leadId);
			lastIdentifiedLeadId = GlobalStore.leadId;
		}

		const data: Record<string, any> = {
			page_name: window.location.pathname,
			...properties,
		};
		if (GlobalStore.leadId) {
			data.lead_id = GlobalStore.leadId;
		}
		if (GlobalStore.applicationID) {
			data.application_id = GlobalStore.applicationID;
		}
		mixpanel.track(event, data);
	} catch (e) {
		console.error("mixpanel track failed", mixpanelObj?.event, e);
	}
}
